import React from "react";
import image1_legacy from '../assets/images/image1_legacy.png'
import image2_legacy from '../assets/images/image2_legacy.png'
import image3_legacy from '../assets/images/image3_legacy.png'
import image4_legacy from '../assets/images/image4_legacy.png'
import image_1_damilor from '../assets/images/image1_damilor.png'
import image_2_damilor from '../assets/images/image2_damilor.png'
import image_3_damilor from '../assets/images/image3_damilor.png'
import image_4_damilor from '../assets/images/image4_damilor.png'
import image1_spellstorm from '../assets/images/spellstorm_1.png'
import image2_spellstorm from '../assets/images/spellstorm_2.png'
import image3_spellstorm from '../assets/images/spellstorm_3.png'
import image4_spellstorm from '../assets/images/spellstorm_4.png'
import '../assets/styles/Project.scss';

function Project() {
    return(
    <div className="projects-container" id="projects">
        <h1>Personal Projects</h1>


        <div className="projects-grid">
            <div className="project">
                <h2>Spellstorm</h2>
                <p>
                    Spellstorm is a multiplayer bullet-heaven game developed for an Introduction to Networking course and presented at academic showcase. 
                    The project explores core networking principles through a fast-paced, survival-based gameplay experience inspired by games like Vampire Survivors.
                    Players face continuous waves of enemies while casting spells, dodging attacks, and surviving as long as possible. The game emphasizes chaotic combat,
                    scaling difficulty, and efficient handling of large numbers of entities on screen.
                </p>
                 <div className="image-row">
                    <a><img src={image1_spellstorm} className="zoom" alt="thumbnail" width="100%"/></a>
                    <a><img src={image2_spellstorm} className="zoom" alt="thumbnail" width="100%"/></a>
                </div>
                <div className="image-row">
                    <a><img src={image3_spellstorm} className="zoom" alt="thumbnail" width="100%"/></a>
                    <a><img src={image4_spellstorm} className="zoom" alt="thumbnail" width="100%"/></a>
                </div>
                
            </div>

            <div className="project">
                <a href="https://reyawon.itch.io/legacy-of-the-occult" target="_blank" rel="noreferrer"><h2>Legacy of the Occult</h2></a>
                <p>A demo of an isometric rouguelite featuring procedural map generation, scalable localization techniques, a dynamic inventory system, 
                    a custom-build NPC dialogue system, a minimap system, and more. This demo was developed as an honors semester project for an introductory
                    data structures and algorithms course and is available to play on Itch.io using the link above.
                </p>
                <div className="image-row">
                    <a href="https://reyawon.itch.io/legacy-of-the-occult" target="_blank" rel="noreferrer"><img src={image1_legacy} className="zoom" alt="thumbnail" width="100%"/></a>
                    <a href="https://reyawon.itch.io/legacy-of-the-occult" target="_blank" rel="noreferrer"><img src={image2_legacy} className="zoom" alt="thumbnail" width="100%"/></a>
                </div>
                <div className="image-row">
                    <a href="https://reyawon.itch.io/legacy-of-the-occult" target="_blank" rel="noreferrer"><img src={image3_legacy} className="zoom" alt="thumbnail" width="100%"/></a>
                    <a href="https://reyawon.itch.io/legacy-of-the-occult" target="_blank" rel="noreferrer"><img src={image4_legacy} className="zoom" alt="thumbnail" width="100%"/></a>
                </div>
            </div>
            <div className="project">
                <h2>Damilor</h2>
                <p>
                    A demo of a roguelike deck-building game developed as part of a semester long honors project for an introductory computer science class.
                    The game features four unique enemy types; a tutorial human, ogres, dragons, and a final boss. Additionally, there was a shop that the
                    player could access between each round of enemies. The shop granted the player access to buying additional card to add to their deck, of
                    which there existed a variety of effects including; increasing health, increasing armour, an exponential damage multiplier at the cost of
                    increasing vulnerability to enemy attacks, etc.
                </p>
                <div className="image-row">
                    <a href="https://reyawon.itch.io/legacy-of-the-occult" target="_blank" rel="noreferrer"><img src={image_1_damilor} className="zoom" alt="thumbnail" width="100%"/></a>
                    <a href="https://reyawon.itch.io/legacy-of-the-occult" target="_blank" rel="noreferrer"><img src={image_2_damilor} className="zoom" alt="thumbnail" width="100%"/></a>
                </div>
                <div className="image-row">
                    <a href="https://reyawon.itch.io/legacy-of-the-occult" target="_blank" rel="noreferrer"><img src={image_3_damilor} className="zoom" alt="thumbnail" width="100%"/></a>
                    <a href="https://reyawon.itch.io/legacy-of-the-occult" target="_blank" rel="noreferrer"><img src={image_4_damilor} className="zoom" alt="thumbnail" width="100%"/></a>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Project;